import type { RouteLocationRaw } from "vue-router"

export const WEBSITE_ERROR_ROUTES = ["SystemMaintenance", "IPBlock"] as const

export type WebsiteErrorStatus = (typeof WEBSITE_ERROR_ROUTES)[number] | "" | null

const isWebsiteErrorRoute = (
  status: WebsiteErrorStatus
): status is (typeof WEBSITE_ERROR_ROUTES)[number] =>
  Boolean(status) && WEBSITE_ERROR_ROUTES.includes(status as never)

export const resolveWebsiteErrorRoute = (
  status: WebsiteErrorStatus,
  currentRouteName?: string | symbol | null
): RouteLocationRaw | undefined => {
  if (!isWebsiteErrorRoute(status)) return undefined
  if (status === currentRouteName) return undefined

  return { name: status }
}
